<div [id]="chartId" class="w-full h-full"></div>
